import type { NDateLocale } from './enUS'
import { it } from 'date-fns/locale'

const dateItIT: NDateLocale = {
  name: 'it-IT',
  locale: it
}

export default dateItIT
